import React, { useState, useEffect, useRef } from "react";
import enableTableSearch from "../utility/table";
import ExportCSV from "./ExportCSV";
import API_BASE_URL from "../config";

function TimberTable({ reload }) {
  const [timbers, setTimbers] = useState([]);
  const inputRef = useRef();
  const tableRef = useRef();

  useEffect(() => {
    fetch(API_BASE_URL + "/api/timber")
      .then((res) => res.json())
      .then((data) => setTimbers(data.timbers))
      .catch((err) => console.error("Error fetching timber:", err));
  }, [reload]);

  useEffect(() => {
    const cleanup = enableTableSearch({
      inputRef,
      tableRef,
      columnIndex: 1,
      noDataText: "No timber found",
    });

    return cleanup;
  }, []);

  return (
    <div id="table-container">
      <div id="header">
        <p>Timber List</p>
      </div>
      <hr />
      <div id="table-actions">
        <ExportCSV
          entries={timbers.map((item, index) => [item.type])}
          header={["TYPE"]}
        />
        <div className="search-box">
          <label>Search:</label>
          <input type="text" id="search" name="search" ref={inputRef} />
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th>SL NO.</th>
            <th>TYPE</th>
          </tr>
        </thead>
        <tbody id="table-body" ref={tableRef}>
          {timbers.map((item, index) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.type}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default TimberTable;
